export default __webpack_public_path__ + "static/media/external-link.6d1a0214.svg";